import React from 'react';

import clsx from 'clsx';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as classes from './CreateSensorWarningModal.module.css';

const CreateSensorWarningModal = ({
    setWarningModalOpen,
    handleReset,
    handleSubmit,
    ...props
}) => {

    const handleCancel = () => {
        handleReset();
        setWarningModalOpen(false);
    };

    return (
        <BobModal
            title={'Agent Warning'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setWarningModalOpen(false)}
        >
            <div className={classes.Body}>
                <span className={clsx('material-symbols-outlined', classes.Warning)}>
                    warning
                </span>
                <span className={classes.Text}>
                    Warning, you are over the recommended 4,000 point limit for an agent. Continuing may cause performance and stability issues. Do you want to continue?
                </span>
            </div>
            <div>
                <BobCancelButton
                    onClick={() => handleCancel()}
                    className={classes.CancelButton}
                    label={'Cancel'}
                />
                <BobConfirmButton
                    onClick={() => handleSubmit()}
                    className={classes.Buttons}
                    label={'Yes'}
                    iconSize={15}
                />
            </div>
        </BobModal>
    );
};

export default CreateSensorWarningModal;
